//Production
export const baseUrl =
  process.env.REACT_APP_FRONTEND_BASEURL ?? "https://sms-app.appantech.com";
export const baseRcsUrl =
  process.env.REACT_APP_FRONTEND_BASEURL ?? "https://sms-app.appantech.com";
export const baseAuthUrl =
  process.env.REACT_APP_FRONTEND_BASEURL ?? "https://sms-app.appantech.com";

// Local
// export const baseUrl =
//   process.env.REACT_APP_FRONTEND_BASEURL ?? "http://localhost:3002";
// export const baseRcsUrl =
//   process.env.REACT_APP_FRONTEND_BASEURL ?? "http://localhost:4000";
// export const baseAuthUrl =
//   process.env.REACT_APP_FRONTEND_BASEURL ?? "http://localhost:3001";

export const AES_SECRET =
  process.env.REACT_APP_AES_SECRET_VALUE ?? "k9mZqP7xT2rYwJ8v";

export const SMS_SERVICE_INDEX = "25,42,43,44,45,83";
export const RCS_SERVICE_INDEX = "26,27,44,45,68,69,70,71";
export const SMS_RCS_SERVICE_INDEX = "25,26,42,43,44,45,68,69,70,71,83";

export const apiList = {
  LOGIN_OTP: baseAuthUrl + "/sms/login",
  LOGIN: baseAuthUrl + "/sms/login-validate",
  LOGOUT: baseAuthUrl + "/master/user/logout",
  FORGOTPWD: baseAuthUrl + "/sms/forgotPassword",
  VALIDATE_OTP: baseAuthUrl + "/sms/valotp",
  UPDATE_PASSWORD: baseAuthUrl + "/sms/updatePassword",
  RESET_USERNAME: baseAuthUrl + "/sms/send-otp",
  VERIFY_OTP_LOGOUT: baseAuthUrl + "/sms/verify-otp-logout",

  AI_DASHBOARD: baseUrl + "/api/dashboard/sms/prompt",

  //GLOBAL API
  FETCH_APPANTECH_ACC_DETAILS: baseUrl + "/master/appantech-accDt/fetch",

  // Company Master
  FETCH_CUSTOMER_DATA: baseUrl + "/master/customer/fetch",
  ALL_ACTIVE_CUSTOMER_DATA: baseUrl + "/master/customer/allData",
  CREATE_CUSTOMER_DATA: baseUrl + "/master/customer/create",
  MODIFY_CUSTOMER_DATA: baseUrl + "/master/customer/modify",
  DELETE_CUSTOMER_DATA: baseUrl + "/master/customer/authorblock",
  AUTH_CUSTOMER_DATA: baseUrl + "/master/customer/authorblock",
  CUST_AUDIT_DATA: baseUrl + "/master/customer/auditData",
  SEND_CREDENTIALS: baseUrl + "/master/customer/sendCredentials",
  SET_PARTNER_RATES: baseUrl + "/master/customer/setPartnerRates",

  FETCH_RETAILER_DATA: baseUrl + "/master/retailer/fetch",
  ALL_ACTIVE_RETAILER_DATA: baseUrl + "/master/retailer/allData",
  CREATE_RETAILER_DATA: baseUrl + "/master/retailer/create",
  MODIFY_RETAILER_DATA: baseUrl + "/master/retailer/modify",
  DELETE_RETAILER_DATA: baseUrl + "/master/retailer/authorblock",
  AUTH_RETAILER_DATA: baseUrl + "/master/retailer/authorblock",

  FETCH_VENDOR_DATA: baseUrl + "/master/vendor/fetch",
  ALL_ACTIVE_VENDOR_DATA: baseUrl + "/master/vendor/allData",
  CREATE_VENDOR_DATA: baseUrl + "/master/vendor/create",
  MODIFY_VENDOR_DATA: baseUrl + "/master/vendor/modify",
  DELETE_VENDOR_DATA: baseUrl + "/master/vendor/authorblock",
  AUTH_VENDOR_DATA: baseUrl + "/master/vendor/authorblock",
  VENDOR_AUDIT_DATA: baseUrl + "/master/vendor/auditData",
  ASSIGN_VENDOR_CODE: baseUrl + "/master/customer/assignVendor",

  FETCH_USER_DATA: baseUrl + "/master/user/fetch",
  CREATE_USER_DATA: baseUrl + "/master/user/create",
  MODIFY_USER_DATA: baseUrl + "/master/user/modify",
  DELETE_USER_DATA: baseUrl + "/master/user/authorblock",
  AUTH_USER_DATA: baseUrl + "/master/user/authorblock",
  USER_AUDIT_DATA: baseUrl + "/master/user/auditData",

  FETCH_BUYSMS_DATA: baseUrl + "/master/txn/fetchBuyTransactions",
  CREATE_BUYSMS_DATA: baseUrl + "/master/txn/buysms",
  CREATE_RCSSMS_DATA: baseUrl + "/master/txn/buyrcs",

  FETCH_SELLSMS_DATA: baseUrl + "/master/txn/fetchSaleTransactions",
  CREATE_SELLSMS_DATA: baseUrl + "/master/txn/salesms",

  OVER_ALL_PROGRESS: "/master/txn/overallProgress",
  OVERVIEW_SMS: "/master/txn/overview",
  SUMMARY_SMS: "/master/txn/summary",

  DASHBOARD_DATA: "/master/txn/dashboard",

  UPDATE_USER_MENU: "/master/user/updateUserMenu",
  FETCH_USER_MENU: "/master/user/fetchUserMenu",

  SMS_TRANSACTION_HISTORY: "/master/txn/fetchCusTxnHistory",
  FETCH_SMS_MASTER: baseUrl + "/master/sms/fetch",
  SMS_MASTER_DATA: baseUrl + "/master/txn/fetchSmsMaster",

  RCS_TRANSACTION_HISTORY: baseUrl + "/master/rcs/fetch",

  DLT_ADD_ENTITY: baseUrl + "/master/dlt/addentity",
  DLT_FETCH_ENTITY: baseUrl + "/master/dlt/fetchentity",
  DLT_ADD_SENDER: baseUrl + "/master/dlt/addsendorid",
  DLT_FETCH_SENDER: baseUrl + "/master/dlt/fetchsendorid",
  DLT_ADD_TEMPLATE: baseUrl + "/master/dlt/addtemplate",
  DLT_FETCH_TEMPLATE: baseUrl + "/master/dlt/fetchtemplate",

  FETCH_ROLE_DATA: baseUrl + "/master/role/fetch",
  CREATE_ROLE_DATA: baseUrl + "/master/role/create",
  MODIFY_ROLE_DATA: baseUrl + "/master/role/modify",
  DELETE_ROLE_DATA: baseUrl + "/master/role/authorblock",
  AUTH_ROLE_DATA: baseUrl + "/master/role/authorblock",

  MENU_USERROLE_DATA: baseUrl + "/master/role/fetchuserrole",
  MENU_FETCH_ROLE_MENU: baseUrl + "/master/role/fetchmenu",

  FETCH_TOPUP_REQ: baseUrl + "/master/txn/fetchwalletload",
  CREATE_TOPUP_REQ: baseUrl + "/master/txn/createwalletload",
  CREATE_SMSTOPUPREQUEST: baseUrl + "/master/txn/smsTopupRequest",
  CREATE_TOPUP_WALLET: baseUrl + "/master/txn/mainWalletTopupRequest",
  MODIFY_WALLET_TOPUP_REQUEST: baseUrl + "/master/txn/modifyWalletTopupRequest",
  CREATE_TOPUP_RCS: baseUrl + "/master/txn/rcsTopupRequest",
  AUTH_TOPUP_REQ: baseUrl + "/master/txn/authorblockwalletload",

  MODIFY_DATA: baseUrl + "/master/dlt/modifyentityid",
  MODIFY_SENDER: baseUrl + "/master/dlt/modifysendorid",
  MODIFY_TEMPLATE: baseUrl + "/master/dlt/modifytemplate",

  DELETE_SENDORID: baseUrl + "/master/dlt/deletesendorid",
  DELETE_TEMPLATEID: baseUrl + "/master/dlt/deletetemplate",

  AUTH_BLOCK_TOPUP_REQ: baseUrl + "/master/txn/authorblockwalletload",
  CHECK_TOPUP_REQ: baseUrl + "/master/txn/checkwalletload",

  FETCH_RCS_AGENT: baseUrl + "/master/customer/FetchRcsAgent",
  MODIFY_RCS_AGENT: baseUrl + "/master/customer/modifyRcsAgent",

  // Bulk Message
  BULK_UPLOAD: baseUrl + "/master/bulk/upload",
  //Globally use sender ID
  BULK_SENDER_ID: baseUrl + "/master/bulk/fetchSendersId",
  FETCH_ENTITY_TEMPLATE_ID: baseUrl + "/master/bulk/fetchEntityTemplate",
  FETCH_BULK_REPORT_DATA: baseUrl + "/master/bulk/fetch",
  FETCH_BY_FILE_PATH: baseUrl + "/master/bulk/fetchByFilePath",
  BULK_UPLOAD_VALIDATE: baseUrl + "/master/bulk/validate",
  BULK_STATS: baseUrl + "/master/bulk/stats",

  // Recharge
  RECHARGE: baseUrl + "/master/recharge/mobile/create",
  DTH: baseUrl + "/master/recharge/dth/create",
  FETCH_OPERATOR_CODES: baseUrl + "/master/recharge/OperatorCodesFetch",

  //Main Wallet Activity
  Fetch_CusWallet_History: baseUrl + "/master/txn/fetchCusWalletHistory",

  // Top Up Main Wallet
  FETCH_MAIN_WALLET_HISTORY: baseUrl + "/master/txn/fetchMainWalletload",
  AUTH_MAIN_WALLET_REQ: baseUrl + "/master/txn/authorblockmainwalletbalance",
  MAIN_WALLET_AUDIT_DATA: baseUrl + "/master/txn/auditDataMainWalletload",

  //SMS History Download
  SMS_FULL_STATEMENT_HISTORY:
    baseUrl + "/master/txn/rquestDownloadSmsTxnHistory",
  SMS_DOWNLOAD_HISTORY: baseUrl + "/master/txn/downloadSmsTxnReportList",

  // RCS History Download
  RCS_FULL_STATEMENT_HISTORY: baseUrl + "/master/rcs/requestDownloadRcsLog",
  RCS_DOWNLOAD_HISTORY: baseUrl + "/master/rcs/downloadRcsReportList",
  RCS_DASHBOARD: baseUrl + "/master/rcs/rcs-dashboard",

  // Rate Check
  RATE_CHECK: baseUrl + "/master/rate/check",

  //Check GST No
  GET_GST_STATUS: baseUrl + "/master/customer/getGstStatus",
  GET_COMPANY_PAN_STATUS: baseUrl + "/master/customer/getCompanyPanStatus",

  //Get RCS ID
  GET_RCS_AGENT_ID: baseUrl + "/master/customer/getRcsAgentId",

  //Recharge
  FETCH_RECHARGE_DATA: baseUrl + "/master/recharge/fetch",
  TXN_REPORT_REQUEST_DOWNLOAD_HISTORY:
    baseUrl + "/master/recharge/requestDownloadBdTxnHistory",
  TXN_REPORT_DOWNLOAD_HISTORY:
    baseUrl + "/master/recharge/downloadBdTxnReportList",
  IP_WHITE_LISTING_CREATE: baseUrl + "/master/ipwhitelist/create",
  FETCH_IP_WHITE_LISTING: baseUrl + "/master/ipwhitelist/allData",

  //Courier Master
  FETCH_COURIER_MASTER_DATA: baseUrl + "/master/courier/fetch",
  CREATE_COURIER_MASTER: baseUrl + "/master/courier/create",
  MODIFY_COURIER_MASTER: baseUrl + "/master/courier/modify",
  AUTH_COURIER_MASTER_DATA: baseUrl + "/master/courier/authorblock",

  //Order Master
  FETCH_ORDER_MASTER_DATA: baseUrl + "/master/order/fetch",
  ORDER_MASTER_DOWNLOAD_HISTORY:
    baseUrl + "/master/order/requestDownloadOrderLog",
  ORDER_MASTER_DOWNLOAD_HISTORY_LIST:
    baseUrl + "/master/order/downloadOrderReportList",

  //Ledger
  FETCH_LEDGER_MASTER_DATA: baseUrl + "/master/ledger/fetch",
  LEDGER_REPORT_DOWNLOAD_HISTORY:
    baseUrl + "/master/ledger/requestDownloadLedgerLog",
  LEDGER_REPORT_DOWNLOAD_HISTORY_LIST:
    baseUrl + "/master/ledger/downloadLedgerReportList",

  //RCS
  RCS_UPLOAD_MOBILE_EXCEL: baseUrl + "/master/rcs/uploadMobileExcel",
  RCS_CAMPAIGN_ID_LIST: baseUrl + "/master/rcs/campaignIds",

  //RCSStandaloneMsg
  CHECK_CAPABILITY: baseUrl + "/master/rcsproxy/checkCapability",
  SEND_RICH_CARD: baseUrl + "/master/rcsproxy/standalone/sendMsg",
  SEND_RICH_REPLY_CARD: baseUrl + "/master/rcsproxy/standalone/suggestedReply",
  SEND_RICH_CALENDAR_CARD:
    baseUrl + "/master/rcsproxy/standalone/suggestedCalenderEvent",
  SEND_RICH_LOCATION_CARD:
    baseUrl + "/master/rcsproxy/standalone/suggestedSharedLocation",
  SEND_RICH_DIALER_CARD:
    baseUrl + "/master/rcsproxy/standalone/suggestedDialerAction",
  SEND_RICH_OPEN_URL_CARD:
    baseUrl + "/master/rcsproxy/standalone/suggestedOpenURL",
  SEND_RICH_COMBINED_CARD:
    baseUrl + "/master/rcsproxy/standalone/withCombination",

  //RCSPlainText
  PLAIN_TEXT: baseUrl + "/master/rcsproxy/plaintext/sendPlainText",
  PLAIN_TEXT_CTA: baseUrl + "/master/rcsproxy/plaintext/sendCTA",
  PLAIN_TEXT_DIALER: baseUrl + "/master/rcsproxy/plaintext/sendDialer",
  PLAIN_TEXT_SUGGESTION: baseUrl + "/master/rcsproxy/plaintext/sendSuggestion",

  //RCS-Carousel
  SEND_CAROUSEL_MESSAGE:
    baseUrl + "/master/rcsproxy/carousel/sendCarouselBasic",
  SEND_CAROUSEL_ADVANCED:
    baseUrl + "/master/rcsproxy/carousel/sendCarouselAdvanced",

  //Update User Menu
  COMPANY_UPDATE_USER_MENU: baseUrl + "/master/company-details/updateUserMenu",

  //Courier Master
  CREATE_ORDER: baseUrl + "/master/courierproxy/createOrder",
  CANCEL_SHIPMENT: baseUrl + "/master/courierproxy/cancelOrder",

  // customer Enquiries
  FETCH_CUSTOMER_ENQUIRIES: baseUrl + "/master/scheduler/fetch",
  CUSTOMER_ENQUIRIES_DOWNLOAD_HISTORY:
    baseUrl + "/master/scheduler/requestDownloadSchedulerLog",
  CUSTOMER_ENQUIRIES_DOWNLOAD_HISTORY_LIST:
    baseUrl + "/master/scheduler/downloadSchedulerReportList",

  CREATE_FREE_TOPUP_REQUEST: baseUrl + "/master/txn/adminFreeTopup",
  CREATE_FREE_WA_TOPUP_REQUEST: baseUrl + "/master/txn/adminFreeWaTopup",
  CREATE_CLAWBACK_TOPUP_REQUEST: baseUrl + "/master/txn/adminClawbackTopup",
  CREATE_CLAWBACK_WA_TOPUP_REQUEST: baseUrl + "/master/txn/adminClawbackWaTopup",

  // Pickup Address
  FETCH_PICKUPADDRESS: baseUrl + "/master/address/fetch",
  CREATE_PICKUPADDRESS: baseUrl + "/master/address/create",
  MODIFY_PICKUPADDRESS: baseUrl + "/master/address/modify",

  // RCS Callback URL
  RCS_CALLBACK_ADD_UPDATE: baseUrl + "/master/customer/update-callback",

  // WhatsApp Templates
  WA_TEMPLATES: baseUrl + "/whatsapp/api/templates",
  WABA_LIST: baseUrl + "/whatsapp/api/wabas",

  // RCS Templates
  RCS_TEMPLATES: baseRcsUrl + "/processor/api/rcs/templates",
  RCS_MESSAGES: baseRcsUrl + "/processor/api/rcs/messages",
};
